var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/data/changelog": "e4d2",
	"./assets/data/changelog.json": "e4d2",
	"./assets/data/database": "fbf8",
	"./assets/data/database.json": "fbf8",
	"./assets/data/nav": "c243",
	"./assets/data/nav.json": "c243",
	"./assets/img_events/bgf 2023.webp": "18ae",
	"./assets/img_events/bgf 2024.webp": "c03b",
	"./assets/img_events/bgf 2025.webp": "b182",
	"./assets/img_events/fij cannes 2024.webp": "0e17",
	"./assets/img_events/ideesbleues 2023.webp": "2fd9",
	"./assets/img_events/ludi bruche 2024.webp": "c5a8",
	"./assets/img_events/ludi nord 2024.webp": "dd56",
	"./assets/img_events/sajou 2023.webp": "a705",
	"./assets/img_events/sortons jouer 2024.webp": "fd58",
	"./assets/img_events/spiel essen 2025.webp": "eb54",
	"./assets/img_events/vichy 2025.webp": "15cd",
	"./assets/img_events/wanna play 2023.webp": "558a",
	"./assets/img_games/CT BRU Profile.webp": "2647",
	"./assets/img_games/DIS Antiquité FR Profile.webp": "0438",
	"./assets/img_games/DIS Préhistoire FR Profile.webp": "3b09",
	"./assets/img_games/T7S box 3 - EN.webp": "5f56",
	"./assets/img_games/T7S game preview 1.webp": "42a5",
	"./assets/img_games/T7S game preview 2.webp": "b0b1",
	"./assets/img_games/T7S game preview 3.png": "29c6",
	"./assets/img_games/T7S game preview 3.webp": "9dff",
	"./assets/img_games/sea cards - ports.webp": "403c",
	"./assets/img_icons/bgg icon.svg": "4b9a",
	"./assets/img_icons/gf icon.svg": "dc16",
	"./assets/img_logos/logo.svg": "3f63",
	"./assets/img_photos/Family Playing.webp": "f633",
	"./assets/img_photos/Game Collection Mini.webp": "7e87",
	"./assets/img_photos/Game Collection.webp": "adbf",
	"./components/app/AppBar": "60dd",
	"./components/app/AppBar.vue": "60dd",
	"./components/app/Footer": "12d5",
	"./components/app/Footer.vue": "12d5",
	"./components/app/Main": "dc65",
	"./components/app/Main.vue": "dc65",
	"./components/app/MainFab": "c652",
	"./components/app/MainFab.vue": "c652",
	"./components/app/MainFooter": "7e1f",
	"./components/app/MainFooter.vue": "7e1f",
	"./components/app/NavigationDrawer": "c462",
	"./components/app/NavigationDrawer.vue": "c462",
	"./components/app/NavigationDrawerList": "adc7",
	"./components/app/NavigationDrawerList.vue": "adc7",
	"./components/general/ButtonHover": "eba4",
	"./components/general/ButtonHover.vue": "eba4",
	"./components/general/ContentParsed": "62fd",
	"./components/general/ContentParsed.vue": "62fd",
	"./components/general/ImageDialog": "0a0e",
	"./components/general/ImageDialog.vue": "0a0e",
	"./components/general/SectionSubtitle": "c3e7",
	"./components/general/SectionSubtitle.vue": "c3e7",
	"./components/general/SectionTitle": "bd32",
	"./components/general/SectionTitle.vue": "bd32",
	"./components/specific/EventItem": "beca",
	"./components/specific/EventItem.vue": "beca",
	"./components/specific/EventsSection": "d979",
	"./components/specific/EventsSection.vue": "d979",
	"./components/specific/GameCard": "b0f0",
	"./components/specific/GameCard.vue": "b0f0",
	"./components/specific/GameCardTitle": "3205",
	"./components/specific/GameCardTitle.vue": "3205",
	"./components/specific/IconBGG": "810e",
	"./components/specific/IconBGG.vue": "810e",
	"./components/specific/IconGF": "8b8b",
	"./components/specific/IconGF.vue": "8b8b",
	"./components/specific/TeamCard": "7134",
	"./components/specific/TeamCard.vue": "7134",
	"./components/specific/TimelineItem": "95d5",
	"./components/specific/TimelineItem.vue": "95d5",
	"./helpers/localeHelper": "a6d7",
	"./helpers/localeHelper.js": "a6d7",
	"./helpers/parser": "478a",
	"./helpers/parser.js": "478a",
	"./holder.txt": "e45c",
	"./i18n": "9225",
	"./i18n.js": "9225",
	"./locales/DE_web-content": "9d5a",
	"./locales/DE_web-content.json": "9d5a",
	"./locales/EN_web-content": "64e1",
	"./locales/EN_web-content.json": "64e1",
	"./locales/FR_web-content": "0ba7",
	"./locales/FR_web-content.json": "0ba7",
	"./locales/languages": "7610",
	"./locales/languages.json": "7610",
	"./main": "56d7",
	"./main.js": "56d7",
	"./mixins/MixinView": "bfad",
	"./mixins/MixinView.js": "bfad",
	"./plugins/vuetify": "402c",
	"./plugins/vuetify.js": "402c",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./styles/variables.scss": "cf1e",
	"./views/Changelog": "f522",
	"./views/Changelog.vue": "f522",
	"./views/Contact": "b8fa",
	"./views/Contact.vue": "b8fa",
	"./views/Games": "a2e9",
	"./views/Games.vue": "a2e9",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/Legal": "519a",
	"./views/Legal.vue": "519a",
	"./views/Team": "0767",
	"./views/Team.vue": "0767",
	"./views/The7Seas": "d602",
	"./views/The7Seas.vue": "d602"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";